import React from 'react';
import {
  Box,
  Flex,
  HStack,
  VStack,
  Text,
  Divider,
  useColorModeValue,
  Icon,
} from '@chakra-ui/react';
import { Package, QrCode, Check, CheckCheck } from 'lucide-react';

const ItemMessage = ({ data, isMe, time, status }) => {
  const bg = useColorModeValue('#38358C', 'gray.800');
  const textColor2 = useColorModeValue('gray.800', 'white');
  const textColor = useColorModeValue('white', 'gray.800');
  const textColor3 = useColorModeValue('white', 'white');
  const mutedText = useColorModeValue('white', 'gray.400');
  const iconBg = useColorModeValue('purple.50', 'whiteAlpha.100');
  const iconColor = useColorModeValue('purple.600', 'purple.300');
  const borderColor = useColorModeValue('gray.100', 'gray.600');
  const errorBg = useColorModeValue('red.50', 'red.900');
  const serialBg = useColorModeValue('gray.50', 'whiteAlpha.50');

  const notMeTimeColor = useColorModeValue('gray.500', 'gray.400');
  const notMeTimeColor2 = useColorModeValue('#38358C', 'white');

  let item;
  try {
    item = typeof data === 'string' ? JSON.parse(data) : data;
  } catch (e) {
    console.error('Failed to parse item data', e);
    return (
      <Box p={3} bg={errorBg} borderRadius="md">
        <Text fontSize="sm" color={textColor}>Error loading item details</Text>
      </Box>
    );
  }

  return (
    <Box
      w="full"
      maxW="340px"
      bg={isMe ? bg : textColor}
      borderRadius="2xl"
      p={4}
      pb={3}
      boxShadow="sm"
      border="1px solid"
      borderColor={borderColor}
      position="relative"
    >
      <VStack align="stretch" spacing={4}>
        {/* Top Header Section */}
        <HStack spacing={4} align="center">
          <Flex
            minW="40px"
            h="40px"
            bg={iconBg}
            borderRadius="lg"
            align="center"
            justify="center"
            shadow="sm"
          >
            <Icon as={Package} size={30} color={iconColor} strokeWidth={2.5} />
          </Flex>
          <VStack align="flex-start" spacing={0} flex={1}>
            {item.companyName && (
              <Text
                fontSize="xs"
                fontWeight="700"
                // color="purple.500"
                opacity={isMe ? 1 : 0.8}
                color={isMe ? textColor3 : textColor2}
                textTransform="uppercase"
                letterSpacing="widest"
              >
                {item.companyName}
              </Text>
            )}
            <Text
              fontSize="md"
              fontWeight="800"
              color={isMe ? textColor3 : notMeTimeColor2}
              lineHeight="1.2"
            >
              {item.itemName}
            </Text>
          </VStack>
        </HStack>

        {item.info && Object.entries(item.info).some(([_, val]) => val !== null && val !== "") && (
          <Divider borderColor={isMe ? borderColor : notMeTimeColor2} />
        )}

        {/* {item.serialNo && (
          <HStack spacing={4} align="center">
            <Flex
              minW="40px"
              h="40px"
              bg={iconBg}
              borderRadius="lg"
              align="center"
              justify="center"
            >
              <Icon as={QrCode} size={20} color={iconColor} />
            </Flex>
            <VStack align="flex-start" spacing={0}>
              <Text fontSize="xs" fontWeight="600" color={isMe ? mutedText : textColor2} opacity={0.8}>
                Serial No.
              </Text>
              <Text fontSize="md" fontWeight="800" color={isMe ? mutedText : notMeTimeColor2} letterSpacing="tight">
                {item.serialNo}
              </Text>
            </VStack>
          </HStack>
        )} */}

        {/* Dynamic Info Fields */}
        {item.info && Object.entries(item.info).some(([_, val]) => val !== null && val !== "") && (
          <VStack align="stretch" spacing={2}>
            {Object.entries(item.info).map(([key, value]) => {
              if (value === null || value === "") return null;
              return (
                <HStack key={key} justify="space-between" align="center" py={1} borderBottom="1px dashed" borderColor={isMe ? borderColor : notMeTimeColor2}>
                  <Text color={isMe ? mutedText : textColor2} opacity={isMe ? 1 : 0.8} fontSize="xs" fontWeight="600" textTransform="capitalize">{key.replace(/([A-Z])/g, ' $1')}</Text>
                  <Text fontWeight="700" color={isMe ? textColor3 : notMeTimeColor2} fontSize="xs">{value}</Text>
                </HStack>
              );
            })}
          </VStack>
        )}

        {/* Timestamp + Read Receipts */}
        <HStack
          alignSelf={'flex-end'}
          spacing={1}
          mt={1}
          opacity={0.75}
        >
          <Text
            fontSize="10px"
            fontWeight="600"
            color={isMe ? mutedText : notMeTimeColor}
          >
            {time}
          </Text>
          {isMe && (
            status ? (
              <CheckCheck size={14} color="#93defeff" strokeWidth={2.5} />
            ) : (
              <Check size={14} color="white" strokeWidth={2.5} />
            )
          )}
        </HStack>
      </VStack>
    </Box>
  );
};

export default ItemMessage;
